import { Link } from "react-router-dom";

const tiles = [
  { title: "A job offer that looks good but feels wrong", blurb: "Career decisions where the obvious answer isn't the right one." },
  { title: "A relationship that keeps looping",            blurb: "When the same fight, doubt, or silence keeps returning." },
  { title: "Money pressure you can't talk about",          blurb: "Choices about income, EMIs, or risk that no one else sees." },
  { title: "A conversation you've been avoiding",          blurb: "With a parent, partner, boss, or yourself." },
  { title: "A life phase where old answers no longer fit", blurb: "Career, marriage, family, or direction shifting under you." },
];

export default function UseCasesScene() {
  return (
    <section
      className="home-band px-5 sm:px-8"
      style={{ background: "hsl(var(--ink))" }}
    >
      <div className="max-w-4xl mx-auto w-full text-left">
        <p className="scroll-reveal section-eyebrow">What you can bring</p>

        <h2 className="scroll-reveal section-heading mt-3">
          Outspoken is made
          <br />
          for those moments.
        </h2>

        {/* Editorial index — no boxes, no stripes. Hairlines + serif numerals. */}
        <div
          className="mt-10 sm:mt-14 border-t"
          style={{ borderColor: "hsl(var(--manuscript) / 0.08)" }}
        >
          {tiles.map((t, i) => (
            <div key={t.title} className="scroll-reveal">

              <Link
                to="/onboarding"
                className="group relative grid grid-cols-[2.25rem_1fr_auto] sm:grid-cols-[3rem_1fr_auto] items-baseline gap-3 sm:gap-5 py-5 sm:py-6 border-b transition-colors"
                style={{ borderColor: "hsl(var(--manuscript) / 0.08)" }}
              >
                {/* hover wash */}
                <span
                  aria-hidden
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                  style={{
                    background:
                      "linear-gradient(90deg, transparent, hsl(var(--manuscript) / 0.025) 30%, hsl(var(--manuscript) / 0.025) 70%, transparent)",
                  }}
                />

                <span
                  className="font-display italic text-manuscript/35 group-hover:text-manuscript/70 transition-colors tabular-nums relative"
                  style={{ fontSize: "clamp(1.1rem, 1.6vw, 1.35rem)" }}
                >
                  {String(i + 1).padStart(2, "0")}
                </span>

                <div className="relative min-w-0">
                  <h3
                    className="font-display text-manuscript leading-tight"
                    style={{ fontSize: "clamp(1.15rem, 2vw, 1.5rem)", letterSpacing: "-0.01em" }}
                  >
                    {t.title}
                  </h3>
                  <p
                    className="mt-1 text-manuscript/55 leading-snug"
                    style={{ fontSize: "clamp(0.82rem, 1vw, 0.9rem)" }}
                  >
                    {t.blurb}
                  </p>
                </div>

                <span
                  aria-hidden
                  className="relative font-display italic text-manuscript/30 group-hover:text-manuscript/80 group-hover:translate-x-0.5 transition-all duration-300"
                  style={{ fontSize: "clamp(0.95rem, 1.3vw, 1.1rem)" }}
                >
                  →
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
